export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-20 md:py-28 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="text-[11px] uppercase tracking-[0.22em] text-brand-teal flex items-center gap-2 mb-5">
            <span className="h-px w-8 bg-brand-gold" /> About Us
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]">
            Dependable support for the systems that care for people.
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed text-base md:text-lg">
            T&amp;J Clinical Solutions is a mobile healthcare support company
            proudly serving New Jersey, surrounding Pennsylvania areas
            including Philadelphia, and New York communities near Staten
            Island. We help healthcare teams do their best work — by handling
            the dispatch, transport, staffing, and clinical support that keep
            operations moving and patients cared for.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Our mission is simple: deliver reliable, professional,
            patient-centered support — and keep growing to meet the evolving
            needs of the healthcare industry.
          </p>

          <dl className="mt-10 grid grid-cols-2 gap-6" data-testid="about-metrics">
            <div className="border-l-2 border-brand-teal pl-4">
              <dt className="text-xs uppercase tracking-widest text-slate-500">Coverage</dt>
              <dd className="mt-1 font-heading text-xl font-semibold text-slate-900">NJ · PA · NY</dd>
            </div>
            <div className="border-l-2 border-brand-gold pl-4">
              <dt className="text-xs uppercase tracking-widest text-slate-500">Scheduling</dt>
              <dd className="mt-1 font-heading text-xl font-semibold text-slate-900">By Appointment</dd>
            </div>
            <div className="border-l-2 border-slate-900 pl-4">
              <dt className="text-xs uppercase tracking-widest text-slate-500">Standard</dt>
              <dd className="mt-1 font-heading text-xl font-semibold text-slate-900">Professionalism</dd>
            </div>
            <div className="border-l-2 border-brand-teal pl-4">
              <dt className="text-xs uppercase tracking-widest text-slate-500">Focus</dt>
              <dd className="mt-1 font-heading text-xl font-semibold text-slate-900">Patient-Centered</dd>
            </div>
          </dl>
        </div>

        <div className="lg:col-span-7 relative">
          <div className="relative border border-slate-200">
            <img
              src="/tj-services-collage.png"
              alt="T&J Clinical Solutions in action — mobile phlebotomy, clinical staff, and branded service vehicle"
              className="w-full h-[360px] md:h-[560px] object-cover"
              loading="lazy"
            />
            <div className="absolute -bottom-px left-0 h-1 w-24 bg-brand-gold" aria-hidden="true" />
          </div>
          <div className="hidden md:block absolute -bottom-8 -left-6 bg-brand-navy text-white px-5 py-3 border border-slate-200">
            <div className="text-[10px] uppercase tracking-[0.22em] text-amber-300 mb-1">
              Built on Trust
            </div>
            <div className="font-heading text-sm font-semibold">
              Compassion · Precision · Excellence
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
